<template>
  <CustomModal
    :id="`m-create-epic_${id}`"
    modalClass="custom-modal_margin-custom custom-modal_delete-modal"
    width="512"
    @onBeforeOpen="clearInput"
  >
    <template #header>
      <div class="custom-modal__space-between">
        <div class="custom-modal__space-between">
          <BaseHeading
            level="3"
            color="monochrome-06"
          >
            Create New Epic
          </BaseHeading>
        </div>
      </div>
    </template>

    <template #body="{ validators }">
      <form @submit.prevent>
        <BorderedInput
          id="newEpicName"
          :modelValue="newEpicName"
          placeholder="Epic Name"
          :validateOnChange="false"
          :rules="validators.isRequiredAndValid({ resourceTypes: 'EPIC', projectId }, 'Epic Name')"
          :maxLength="TITLE_MAX_LENGTH"
          :focus="true"
          @update:modelValue="handleInput"
          @enter="onCreateEpic"
        />
      </form>
    </template>

    <template #footer="{ hide, validate }">
      <ControlButtons
        @save="onCreateEpic(validate)"
        @cancel="hide"
      >
        <template #save> Create Epic </template>
      </ControlButtons>
    </template>
  </CustomModal>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"
import { Getter } from "s-vuex-class"

import ControlButtons from "@/components/ControlButtons/index.vue"
import DropdownBordered from "@/components/Dropdown/DropdownBordered.vue"
import BorderedInput from "@/components/Form/BorderedInput.vue"
import CustomModal from "@/components/Modal/index.vue"

import { TITLE_MAX_LENGTH } from "@/helpers/validationHelper"
import { Getters } from "@/store"

@Options({
  name: "ModalCreateEpic",
  components: {
    CustomModal,
    BorderedInput,
    DropdownBordered,
    ControlButtons
  }
})
export default class ModalCreateEpic extends Vue {
  @Prop({ default: "" }) readonly id: string

  @Getter(Getters.GET_SESSION_PROJECT_ID) projectId: string

  TITLE_MAX_LENGTH = TITLE_MAX_LENGTH
  newEpicName = ""

  clearInput() {
    this.newEpicName = ""
  }

  handleInput(payload) {
    this.newEpicName = payload["value"]
  }

  hide() {
    this.$modal.hide(`m-create-epic_${this.id}`)
  }

  async onCreateEpic(validate) {
    const result = await validate()
    if (!result.valid) {
      return
    }
    this.$emit("onCreateEpic", this.newEpicName)
    this.hide()
  }
}
</script>
